import { AlternativesCardProps } from "@components/alternatives/AlternativesCards";
import { HeroSectionProps } from "@components/alternatives/HeroSection";
import { NavLink } from "@pages/case-study/alrannan-administrative-services";

export const alternativesCardsDetails: AlternativesCardProps[] = [
    {
        id: "interakt",
        imageUrl: "https://assets.gallabox.com/gb-home/alternatives/interakt-alternatives.png",
        title: "11 Best Interakt alternatives to scale your WhatsApp marketing",
        imgAlt: "interakt-alternatives",
        externalLink: "/alternatives/interakt",
    },
    {
        id: "wati",
        imageUrl: "https://assets.gallabox.com/gb-home/alternatives/wati-alternatives.png",
        title: "10 Best Wati alternatives to scale your WhatsApp marketing",
        imgAlt: "wati-alternatives",
        externalLink: "/alternatives/wati",
    },
    {
        id: "aisensy",
        imageUrl: "https://assets.gallabox.com/gb-home/alternatives/aisensy/aisensy.png",
        title: "Top AiSensy Alternatives to scale your revenue on WhatsApp",
        imgAlt: "aisensy",
        externalLink: "/alternatives/aisensy",
    },
    {
        id: "quickreply",
        imageUrl: "https://assets.gallabox.com/gb-home/alternatives/quickreply/quickreply-ai.png",
        title: "10 Best QuickReply alternatives to try in 2025",
        imgAlt: "quickreply-ai",
        externalLink: "/alternatives/quickreply",
    },
    {
        id: "rasayel",
        imageUrl: "https://assets.gallabox.com/gb-home/alternatives/rasayel/rasayel.png",
        title: "Top Rasayel alternatives to manage prospects and customers on WhatsApp",
        imgAlt: "rasayel",
        externalLink: "/alternatives/rasayel",
    },
    {
        id: "doubletick",
        imageUrl: "https://assets.gallabox.com/gb-home/alternatives/doubletick-io/doubletick.png",
        title: "Top 10 DoubleTick Alternatives for WhatsApp Automation in 2025",
        imgAlt: "doubletick",
        externalLink: "/alternatives/doubletick",
    },
    {
        id: "zixflow",
        imageUrl: "https://assets.gallabox.com/gb-home/alternatives/zixflow/zixflow.png",
        title: "Top 10 Zixflow Alternatives for WhatsApp Automation in 2025",
        imgAlt: "zixflow",
        externalLink: "/alternatives/zixflow",
    },
];

export const herosectionData: HeroSectionProps = {
    title: "Gallabox alternatives and competitors",
    description: "Explore how Gallabox alternatives fare in terms of features, functionalities, and use cases in the WhatsApp Business API market.",
    primaryButtonText: "Try for Free",
    imageUrl: "https://assets.gallabox.com/gb-home/alternatives/gallabox-alternatives.png",
    imgAlt: "alternative",
};

export const interaktNavLinks: NavLink[] = [
    { id: "Gallabox", label: "1. Gallabox" },
    { id: "Yellow.ai", label: "2. Yellow.ai" },
    { id: "360Dialog", label: "3. 360Dialog" },
    { id: "Twilio", label: "4. Twilio" },
    { id: "Kaleyra", label: "5. Kaleyra" },
    { id: "DoubleTick", label: "6. DoubleTick" },
    { id: "CM.com", label: "7. CM.com" },
    { id: "GupShup", label: "8. GupShup" },
    { id: "Verloop", label: "9. Verloop" },
    { id: "Wati", label: "10. Wati" },
    { id: "Yalo", label: "11. Yalo" },
];

export const watiNavLinks: NavLink[] = [
    { id: "Gallabox", label: "1. Gallabox" },
    { id: "Interakt", label: "2. Interakt" },
    { id: "Twilio", label: "3. Twilio" },
    { id: "Freshchat", label: "4. Freshchat" },
    { id: "Intercom", label: "5. Intercom" },
    { id: "Zendesk Suite", label: "6. Zendesk Suite" },
    { id: "Zixflow", label: "7. Zixflow" },
    { id: "DelightChat", label: "8. DelightChat" },
    { id: "360dialog", label: "9. 360dialog" },
    { id: "BotPenguin", label: "10. BotPenguin" },
    { id: "Kaleyra", label: "11. Kaleyra" },
];

export const aisensyNavLinks: NavLink[] = [
    { id: "Gallabox", label: "1. Gallabox" },
    { id: "DelightChat", label: "2. DelightChat" },
    { id: "WaliChat", label: "3. WaliChat" },
    { id: "BotPenguin", label: "4. BotPenguin" },
    { id: "Twilio", label: "5. Twilio" },
    { id: "Tidio", label: "6. Tidio" },
    { id: "ChatBot", label: "7. ChatBot" },
    { id: "Wati", label: "8. Wati" },
    { id: "Gupshup", label: "9. Gupshup" },
    { id: "Infobip", label: "10. Infobip" },
];

export const quickreplyNavLinks: NavLink[] = [
    { id: "Gallabox", label: "1. Gallabox" },
    { id: "DelightChat", label: "2. DelightChat" },
    { id: "LimeChat", label: "3. LimeChat" },
    { id: "Zoko", label: "4. Zoko" },
    { id: "Messagio", label: "5. Messagio" },
    { id: "Contlo", label: "6. Contlo" },
    { id: "Wati", label: "7. Wati" },
    { id: "Freshchat", label: "8. Freshchat" },
    { id: "Bitespeed", label: "9. Bitespeed" },
    { id: "AiSensy", label: "10. AiSensy" },
];

export const rasayelNavLinks: NavLink[] = [
    { id: "Gallabox", label: "1. Gallabox" },
    { id: "Interakt", label: "2. Interakt" },
    { id: "DelightChat", label: "3. DelightChat" },
    { id: "Zixflow", label: "4. Zixflow" },
    { id: "Respond.io", label: "5. Respond.io" },
    { id: "FreshChat", label: "6. FreshChat" },
    { id: "Twilio", label: "7. Twilio" },
    { id: "Zoko", label: "8. Zoko" },
    { id: "Trengo", label: "9. Trengo" },
    { id: "MessageBird", label: "10. MessageBird" },
];

export const doubleTickNavLinks: NavLink[] = [
    { id: "Gallabox", label: "1. Gallabox" },
    { id: "QuickReply", label: "2. QuickReply" },
    { id: "Wati", label: "3. Wati" },
    { id: "Brevo", label: "4. Brevo" },
    { id: "Interakt", label: "5. Interakt" },
    { id: "Superlemon", label: "6. Superlemon" },
    { id: "Zixflow", label: "7. Zixflow" },
    { id: "AiSensy", label: "8. AiSensy" },
    { id: "Respond.io", label: "9. Respond.io" },
    { id: "Zoko", label: "10. Zoko" },
];
export const ZixflowNavLinks: NavLink[] = [
    { id: "Gallabox", label: "1. Gallabox" },
    { id: "Interakt", label: "2. Interakt" },
    { id: "Wati", label: "3. Wati" },
    { id: "Hubspot Sales Hub", label: "4. Hubspot Sales Hub" },
    { id: "ActiveCampaign", label: "5. ActiveCampaign" },
    { id: "Twilio Flex", label: "6. Twilio Flex" },
    { id: "Gupshup", label: "7. Gupshup" },
    { id: " Trengo", label: "8.  Trengo" },
    { id: "Keap", label: "9. Keap" },
    { id: "Pipedrive", label: "10. Pipedrive" },
];
